module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABN0lEQVRYR+2XgU3DMBBFXyeADQoTlBHoBrABTEA3ADagE5QNGAHYACagI8AEoIdsqShxHcsREcInWUol/7t/90/J74yJYzZxfRqBoRM4BbbhnAAHCek+gBfgCJgDzzmJcwRugOuQ5Bbw93uGwGG4F3FixPbGPgL3wFlI5rOFSyPin4BVHzhFwJE/AktAcE0ox1sqV4qAY5O9eo8RNuEx749IEYhdO4kxwnxKaFOTEbBwp6HfnEAVgTvgqlCL9c7mJyUdOgE32VMS8cUlpppASeG+u3+fQNuBtgNtB/7fDqi5XmDMz7FeseOKUt+CC2ADHAcjWiNBdESXgNZukB/wkow/gfMKEhZ/gO//H73uap8pFSDjRYUvVMJXwInaUCdytlyAYMmU+kMLejpj32UxhECN/llsI/AFVxRUIXGyPtoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/order.png
// module id = AwSN
// module chunks = 1